/**
 * Fetches product information from a given URL or using a product handle.
 *
 * This function makes an HTTP GET request to retrieve product details in JSON format. If neither `url` nor `handle` is provided, it returns `false`.
 *
 * @param {Object} params - The parameters for fetching the product.
 * @param {string} [params.url] - The URL to fetch the product information from. If not provided, the `handle` will be used.
 * @param {string} [params.handle] - The product handle. Used to construct the URL if `url` is not provided.
 * @returns {Promise<Object|boolean>} A promise that resolves to the product information object if successful, or `false` if neither `url` nor `handle` is provided.
 * @throws {Error} Will throw an error if the network request fails or if the response is not ok.
 */
export const getProduct = async ({ url, handle }) => {
  if (!handle && !url) return false;
  return await fetch(`${url ? url : `${window.Shopify.routes.root}products/${handle}`}.js`)
    .then((res) => {
      if (!res.ok) throw new Error(`Fetch result was not ok. Requested URL: ${res.url}`);
      return res.json();
    })
    .catch((err) => {
      console.error('Fetch product info failed:', err);
      throw err;
    });
};
